import { API_ROOT_URL } from "../config";
import { handleResponse } from "../helpers";
import { sessionStatus } from "../store/reducers/sessionStatus.reducer";


export const sessionService = {
  OpenTokService,
  UpdateSessionStatus,
  CreateNote,
  getSessions,
  getSessionStatus,
  getNatureIssues,
  UpdateSessionHistoryStatus,
  UpdateIssueNature,
  csvSessions,
  resetSessionCap,
};

function CreateNote(note, user_id, appointment_id) {
  const token = JSON.parse(localStorage.getItem("token"));

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    },
    body: JSON.stringify({
      body: note,
      user: user_id,
      appointment: appointment_id
    })
  };
  return fetch(`${API_ROOT_URL}/appointments/notes/`, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response;
    });
}

function UpdateSessionStatus(status) {
  const token = JSON.parse(localStorage.getItem("token"));

  const requestOptions = {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    },
    body: JSON.stringify({ status: status })
  };
  return fetch(
    `${API_ROOT_URL}/appointments/${sessionStorage.getItem(
      "appointment_id"
    )}/`,
    requestOptions
  )
    .then(handleResponse)
    .then(userSession => {
      return userSession;
    });
}

function OpenTokService(appointment_id, os, browser, device) {
  const token = JSON.parse(localStorage.getItem("token"));
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    },
    body: JSON.stringify({
      appointment_id: appointment_id,
      os,
      browser,
      device
    })
  };
  return fetch(`${API_ROOT_URL}/sessions/create/`, requestOptions)
    .then(handleResponse)
    .then(userSession => {
      return userSession;
    });
}

function getSessions(pageNum, itemsCount, startDate, endDate) {
  const token = JSON.parse(localStorage.getItem("token"));
  let api = startDate && endDate ?
    `${API_ROOT_URL}/sessions/?ordering=-appointment__slot__date_time&is_paginated=true&start_date=${startDate}&end_date=${endDate}&page=${pageNum}&page_size=${itemsCount}`
    : `${API_ROOT_URL}/sessions/?is_paginated=true&page_size=${itemsCount}&page=${pageNum}`

  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: "Bearer " + token
    }
  };
  return fetch(
    api,
    requestOptions
  )
    .then(handleResponse)
    .then(UpdateSessionStatus => {
      return UpdateSessionStatus;
    });
}

function csvSessions(startDate, endDate) {
  const token = JSON.parse(localStorage.getItem("token"));
  let api = `${API_ROOT_URL}/sessions/?is_paginated=false&start_date=${startDate}&end_date=${endDate}`

  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: "Bearer " + token
    }
  };
  return fetch(
    api,
    requestOptions
  )
    .then(handleResponse)
    .then(UpdateSessionStatus => {
      console.log("sessions from CSV function", UpdateSessionStatus)
      return UpdateSessionStatus;
    });
}

function getSessionStatus() {
  const token = JSON.parse(localStorage.getItem("token"));
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: "Bearer " + token
    }
  };

  return fetch(
    `${API_ROOT_URL}/appointments/get_all_call_status/`,
    requestOptions
  )
    .then(handleResponse)
    .then(allStatus => {
      return allStatus;
    });
}

async function getNatureIssues() {
  const token = JSON.parse(localStorage.getItem("token"));
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: "Bearer " + token
    }
  };

  let res = await fetch(
    `${API_ROOT_URL}/appointments/get_nature_of_issues/`,
    requestOptions
  )
    .then(handleResponse)
    .then(allStatus => {
      return allStatus;
    });

  return res
}

function UpdateSessionHistoryStatus(status) {
  const token = JSON.parse(localStorage.getItem("token"));

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    },
    body: JSON.stringify(status)
  };
  return fetch(
    `${API_ROOT_URL}/appointments/set_appointment_status/`,
    requestOptions
  )
    .then(handleResponse)
    .then(userSession => {
      return userSession;
    });
}

function UpdateIssueNature(nature) {
  const token = JSON.parse(localStorage.getItem("token"));

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    },
    body: JSON.stringify(nature)
  };
  return fetch(
    `${API_ROOT_URL}/appointments/set_nature_of_issue/`,
    requestOptions
  )
    .then(handleResponse)
    .then(natureOfIssue => {
      return natureOfIssue;
    });
}
function resetSessionCap(payload) {
  const token = JSON.parse(localStorage.getItem("token"));
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(payload),
  };
  return fetch(`${API_ROOT_URL}/patients/sessioncaps/`, requestOptions)
    .then((response) => {
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      return response.json(); 
    });
}



// WEBPACK FOOTER //
// ./src/services/session.service.js